import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-10 text-center">为什么选择棒棒TV</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group flex flex-col items-center text-center p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}